import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

const Tabs: ThemeOptions['components'] = {
  MuiTab: {
    styleOverrides: {
      root: {
        minHeight: theme.spacing(4),
        textTransform: 'capitalize',

        '&.Mui-selected': {
          fontWeight: 600,
        },

        '&$disabled': {
          pointerEvents: 'all',
        },
      },
      textColorPrimary: {
        color: palette.text.primary,

        '&.Mui-selected': {
          color: palette.text.primary,
        },

        '&$disabled': {
          color: palette.text.primary,
        },
      },
      /*
      https://github.com/mui/material-ui/issues/32699
      indicator: {
        height: 4,
        color: palette.text.primary,
      },
      */
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: theme.spacing(3),
      },
    },
  },
  /*
  https://github.com/mui/material-ui/issues/32699
  PrivateTabIndicator: {
    styleOverrides: {
      root: {
        height: 4,
      },
      colorPrimary: {
        backgroundColor: palette.text.primary,
      },
      colorSecondary: {
        backgroundColor: palette.primary.main,
      },
    },
  },
  */
};

export default Tabs;
